import reactNavigation from './react-navigation';

export default {
    reactNavigation,
};
